import { type IEvent } from 'clients/PlatformApi';
import { useCallback, useState } from 'react';

export interface UsePrintPanelProps {
  event: IEvent;
  printMode: boolean;
  closePanel: () => void;
}

export interface UsePrintPanel {
  openPrintPanel: (event: IEvent, printMode?: boolean) => void;
  closePanel: () => void;
  printPanelProps: UsePrintPanelProps | undefined;
}

export function usePrintPanel(): UsePrintPanel {
  const [printPanelProps, setPrintPanelProps] = useState<UsePrintPanelProps | undefined>(undefined);

  const closePanel = useCallback(() => setPrintPanelProps(undefined), []);

  const openPrintPanel = useCallback(
    (event: IEvent, printMode: boolean = false) => {
      setPrintPanelProps({
        event,
        printMode,
        closePanel,
      });
    },
    [closePanel],
  );

  return {
    openPrintPanel,
    closePanel,
    printPanelProps,
  };
}
